module.exports = __webpack_public_path__ + "static/media/the-game-afl-2026.a16b34b4.jpg";